import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCustomerAddressSearch = () => {
  const customerAddressSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/customer/address/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { customerAddressSearch }
}

export default InteractorCustomerAddressSearch
